<div class="lum-c-ui-fulfillment-action-confirmation-dialog">
  <div mat-dialog-title>
    <h2>{{ data.title }}</h2>
  </div>

  <div mat-dialog-content class="dialog-content-fix">
    <h3 *ngIf="data.message" class="message-text">{{ data.message }}</h3>

    <div class="scrollable-table-container">
      <div class="table-wrapper">
        <table class="lum-table lum-table--striped w-100">
          <thead>
            <tr>
              <th>Fulfillment Order ID</th>
              <th>Target Fulfillment Channel</th>
              <th>Warehouse Group</th>
              <th>Fulfillment Channel Store</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let item of data.fulfillmentConfirmationValues;
                trackBy: trackById
              "
            >
              <td>{{ item.orderId }}</td>
              <td>{{ item.fulfillmentChannelName }}</td>
              <td>{{ item.warehouseGroupName }}</td>
              <td>{{ item.fulfillmentChannelStoreName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <mat-dialog-actions align="center">
    <button
      mat-button
      class="lum-button lum-button--secondary lum-button--medium w-20 mx-1"
      (click)="onNoClick()"
    >
      No
    </button>
    <button
      mat-button
      class="lum-button lum-button--medium w-20"
      (click)="onYesClick()"
    >
      Yes
    </button>
  </mat-dialog-actions>
</div>
